var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AxiosError } from "axios";
export function getReportFileTransportConfig(client, options) {
    if (!options)
        return {};
    return {
        signal: options.signal,
        // A per-call adapter lets Axios finish authentication/interceptors without buffering a Blob in RN.
        adapter: (config) => __awaiter(this, void 0, void 0, function* () {
            const headers = {};
            for (const [name, value] of Object.entries(config.headers.toJSON())) {
                if (value !== undefined && value !== null && value !== false)
                    headers[name] = String(value);
            }
            const result = yield options.download({ url: client.axiosInstance.getUri(config), headers, signal: config.signal });
            const response = Object.assign(Object.assign({}, result), { config, statusText: "" });
            if (result.status < 200 || result.status >= 300) {
                throw new AxiosError("Report download failed", AxiosError.ERR_BAD_RESPONSE, config, undefined, response);
            }
            return response;
        }),
    };
}
